export default __webpack_public_path__ + "static/background-home-tablet-5f1f2ed22cbc10c365fe3ba322cac1a2.png";